// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"128":"476d4fa2","158":"195b4928","362":"069c1d11","474":"445ed5df","566":"4772ab1a"}[chunkId] + ".chunk.css";
};